import React from 'react';

const TeamHeader = () => {
  return (
    <div className="row">
      <div className="col-lg-8">
        <div className="subtitle bigger">
          Team
          <div className="extra">
            We strongly believe that great products are possible when the
            business side and the technology side easily communicate and
            understand each other.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamHeader;
